module.exports = __webpack_public_path__ + "images/category_lp/earphone/assessment_achievements/3_57c6ef5a117c993f58532123b2bc80ed.jpg";